import React from 'react';
import { ICON_MAPPING, DEFAULT_ICON } from '@/constants/iconMapping';

interface DynamicIconProps {
    name: string;
    className?: string;
}

const DynamicIcon: React.FC<DynamicIconProps> = ({ name, className }) => {
    // Direct lookup
    let IconComponent = ICON_MAPPING[name];

    // Case-insensitive lookup fallback
    if (!IconComponent) {
        const lowerName = name.toLowerCase();
        const foundKey = Object.keys(ICON_MAPPING).find(key => key.toLowerCase() === lowerName);
        if (foundKey) {
            IconComponent = ICON_MAPPING[foundKey];
        }
    }

    // Default fallback
    if (!IconComponent) {
        IconComponent = DEFAULT_ICON;
    }

    return <IconComponent className={className} />;
};

export default DynamicIcon;
